<template>
  <div>
    <div class="kt-portlet kt-portlet--bordered">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">
            Create {{ getFeedLabel(true) }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group kt-form__group">
              <label>Feed Type</label>
              <multiselect
                v-model="feed_type"
                :options="feed_types"
                label="label"
                placeholder="Select a Feed Type..." />
            </div>

            <div class="form-group kt-form__group">
              <label for="feed_name">Name*</label>
              <input id="feed_name" v-model="feed.name"
                     type="text" class="form-control kt-input"
                     placeholder="Enter name...">
            </div>
            <div class="form-group kt-form__group">
              <label for="feed_description">Description</label>
              <tip-tap v-model="feed.description" input-id="feed_description" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-5 mr-auto">
                <display-with-selection-modal :preselected-artwork="artwork_to_display"
                                              feed-suitable-only
                                              lock-suitability
                                              @selected="(ev) => (selected_artwork = ev.selected_artwork)" />
              </div>
            </div>
            <div class="row">
              <div v-if="feed_type && feed_type.format === 'podcast'"
                   class="form-group col-12 col-md-8 col-lg-8 mr-auto">
                <display-with-selection-modal :preselected-artwork="banner_to_display"
                                              label="Banner Artwork"
                                              banner-suitable-only
                                              lock-suitability
                                              clearable
                                              @selected="ev => selected_banner_artwork = ev.selected_artwork" />
              </div>
            </div>
            <div class="form-group kt-form__group">
              <label for="feed_tags">Tags</label>
              <multiselect
                id="feed_tags"
                v-model="ms_tag_values"
                :options="auto_complete_tags"
                :multiple="true"
                :taggable="true"
                track-by="uuid"
                label="name"
                @tag="addNewTag" />
              <ss-checkbox id="feed-populate-from-tags" v-model="feed.populate_from_tags" class="mt-4">
                Populate Feed with {{ getItemLabel() }}s matching tags
              </ss-checkbox><br>
              <ss-checkbox id="feed-auto-sync-items-tags" v-model="feed.auto_sync_items_by_tags">
                Automatically sync {{ getItemLabel() }}s with matching tags
              </ss-checkbox>
              <br>
              <span class="form-text text-muted">
                When a tag is added to an {{ getItemLabel() }}, or this feed, {{ getItemLabel() }}s with corresponding tags will be synced automatically.<br>
                Using this setting will cause {{ getItemLabel() }}s with matching tags to be re-added if manually removed.
              </span>
              <ss-checkbox id="feed-sync-to-website" v-model="feed.sync_to_website"
                           v-perms="['api']"
                           class="mt-4">
                Sync To Website
              </ss-checkbox>
              <br>
              <span v-perms="['api']" class="form-text text-muted">
                If you have website integrated with Timbre, this can be used as a flag to determine if this feed should be displayed.<br>
              </span>
            </div>
            <div class="form-group kt-form__group">
              <label style="padding-right: 10px;">{{ getItemLabel(true) }} Ordering</label>
              <div class="kt-radio-inline">
                <!--
                  <label class="kt-radio">
                    <input v-model="feed.ordering" type="radio"
                            name="manual_order"
                            :value="0"> Manual
                    <span />
                  </label>
                  -->
                <label class="kt-radio">
                  <input v-model="feed.ordering" type="radio"
                         name="newest_order"
                         :value="1"> Date Added Newest
                  <span />
                </label>
                <label class="kt-radio">
                  <input v-model="feed.ordering" type="radio"
                         name="oldest_order"
                         :value="2"> Date Added Oldest
                  <span />
                </label>
                <label class="kt-radio">
                  <input v-model="feed.ordering" type="radio"
                         name="newest_published_order"
                         :value="3"> Date Published Newest
                  <span />
                </label>
                <label class="kt-radio">
                  <input v-model="feed.ordering" type="radio"
                         name="oldest_published_order"
                         :value="4"> Date Published Oldest
                  <span />
                </label>
                <label class="kt-radio">
                  <input v-model="feed.ordering" type="radio"
                         name="random_order"
                         :value="6"> Random
                  <span />
                </label>
              </div>
            </div>
            <div class="form-group kt-form__group">
              <label>Update Type</label>
              <div class="kt-radio-inline">
                <label class="kt-radio">
                  <input v-model="feed.update_type" type="radio"
                         name="update_instant"
                         :value="0"> Publish changes instantly
                  <span />
                </label>
                <label class="kt-radio">
                  <input v-model="feed.update_type" type="radio"
                         name="update_manual"
                         :value="1"> Publish changes manually
                  <span />
                </label>
              </div>
              <span class="form-text text-muted">
                Instant : Feed RSS and Live Playlists will update as soon as changes are made<br>
                Manual : Feed RSS and Live Feeds will only update when you click the 'Publish Changes' button.
              </span>
            </div>
          </div>
          <div class="col-12">
            <button class="btn btn-ss-standout"
                    :disabled="!feed_type || !feed.name || loading"
                    @click="createFeed">
              <loader v-if="loading" small class="mr-2" />
              <i v-else class="la la-save" />
              <span>Create</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TaggableModelMixin from 'VueMixins/TaggableModelMixin';
import FeedCreateEditMixin from "VueMixins/Feeds/FeedCreateEditMixin";
import FeedsApiMixin from 'VueMixins/Feeds/FeedsApiMixin';
import DisplayWithSelectionModal from "VuePartials/Artwork/DisplayWithSelectionModal";

export default {
  components: {
    DisplayWithSelectionModal,
  },
  mixins: [TaggableModelMixin, FeedCreateEditMixin, FeedsApiMixin],
  data: () => ({
    feed: {
      name: null,
      description: "",
      import_url: null,
      ordering: 1,
      update_type: 0,
      artwork: null,
      populate_from_tags: false,
      auto_sync_items_by_tags: false,
    },
    loading: false,
  }),
  computed: {
    filteredTags() {
      return this.auto_complete_tags.filter(i =>
        new RegExp(this.tag.name, "i").test(i.text),
      );
    },
  },

  mounted() {
    this.fetchTags();
    this.getFeedTypes();
  },

  methods: {
    async createFeed() {
      const artwork_uuid = this.feed.artwork?.uuid ?? this.selected_artwork?.uuid ?? null;
      const banner_uuid = this.feed.banner_artwork?.uuid ?? this.selected_banner_artwork?.uuid ?? null;

      this.loading = true;
      const res_data = (await this.createFeeds({
        feed_type_id: this.feed_type.id,
        feed_name: this.feed.name,
        feed_description: this.feed.description,
        feed_import_url: this.feed.import_url,
        feed_ordering: this.feed.ordering,
        feed_update_type: this.feed.update_type,
        populate_from_tags: this.feed.populate_from_tags,
        tags: this.ms_tag_values,
        feed_artwork_uuid: artwork_uuid,
        feed_banner_artwork_uuid: banner_uuid,
        auto_sync_items_by_tags: this.feed.auto_sync_items_by_tags,
        sync_to_website: this.feed.sync_to_website,
      }))[0].data;

      if (res_data.success) { // show it spinning until they're redirected
        window.location.href = `/feeds/${res_data.data.uuid}/edit`;
      } else {
        this.loading = false;
      }
    },
  },
};
</script>
